import React from 'react';

import { cn } from 'helpers/classnames';
import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/account/returns/returnsAndExchangesUPSPickUpAddress.scss';

const ReturnsAndExchangesUPSPickUpAddress = ({ className = '', UPSPickUpAddress = {} }) => {
  const { testId } = useMartyContext();

  const { addressLine1, addressLine2, districtOrCounty, city, stateOrRegion, postalCode, countryName, fullName } = UPSPickUpAddress;

  return (
    <div className={cn(className, css.returnsAndExchangesUPSPickUpAddress)} data-test-id="returnsAndExchangesUPSPickUpAddress">
      <b className={css.columnTitle} data-test-id={testId('addressColumnTitle')}>
        Pick-Up Address:
      </b>
      <div className={css.addressDetails}>
        {fullName && <p data-test-id={testId('addressCardFullName')}>{fullName}</p>}
        {addressLine1 && <p data-test-id={testId('addressCardAddress1')}>{addressLine1}</p>}
        {addressLine2 && <p data-test-id={testId('addressCardAddress2')}>{addressLine2}</p>}
        {districtOrCounty && <p data-test-id={testId('addressCardDistrict')}>{districtOrCounty}</p>}
        <p data-test-id={testId('addressCardCityStateZip')}>
          {city && <span>{city},&nbsp;</span>}
          {stateOrRegion && <abbr>{stateOrRegion}&nbsp;</abbr>}
          {postalCode && <span>{postalCode}</span>}
        </p>
        {countryName && <p data-test-id={testId('addressCardCountry')}>{countryName}</p>}
      </div>
    </div>
  );
};

export default ReturnsAndExchangesUPSPickUpAddress;
